import http from '@/utils/httpService';
import { rootPath } from '@/utils/globalParam';
import fileExport from '@/utils/fileExport';

// 保单合同分页查询
export const policyList=data=>{
    return http.Axios.post(rootPath+'/api/policy/policyList',data)
};

// 保单合同详情
export const policyDetail=data=>{
    return http.Axios.post(rootPath+'/api/policy/policyDetail',data)
};

// 导出保单被保人
export const insuredExport=data=>{
    return fileExport('被保人清单.xlsx',data,'/api/policy/export')
};

// 查询方案下险种信息
export const productListPlan=data=>{
    return http.Axios.post(rootPath + '/api/policy/productListPlan', data)
};

// 查询计划下被保人
export const planInsured=data=>{
    return http.Axios.post(rootPath + '/api/policy/planInsured', data)
};

//查询主保险人连带
export const getSubPolicyInsured=data=>{
    return http.Axios.post(rootPath + '/api/policy/getSubPolicyInsured', data)
};
